module.exports = __webpack_public_path__ + "static/media/iconDiputado.413d7da0.svg";